'use client'

import Image from 'next/image'
import s from './style.module.scss'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {GameEvent} from '@app/[lang]/(common-header-footer)/(home)/events'
import clsx from 'clsx'
import {ReffererLayout} from '@app/analytics/analytics-provider/types'
import {useTriggerImpressions} from '@gamezop/analytics-sdk/client'
import GameLinkWithImpressionTracking from '@app/components/custom-links/game-link/game-link-view-intersection'

type Props = {
  gameCode: string
  gameName: string
  gameNameEn: string
  propertyCode: string
  isMobile: boolean
  layout: string
  additionalAttributes?: Record<string, any>
  className?: string
  reffererLayout?: ReffererLayout
}

const CardSquare = ({
  gameCode,
  gameName,
  gameNameEn,
  propertyCode,
  isMobile,
  layout,
  additionalAttributes,
  className,
  reffererLayout,
}: Props) => {
  const imageSize = isMobile ? 'm' : 'l'
  const triggerImpressions = useTriggerImpressions()

  return (
    <GameLinkWithImpressionTracking
      gameCode={gameCode}
      gameName={gameName}
      propertyCode={propertyCode}
      className={clsx(s.card, className)}
      onClick={() =>
        triggerAnalytics(GameEvent.CardClicked, {
          layout,
          'game-name': gameNameEn,
          'game-code': gameCode,
          ...additionalAttributes,
        }).sendAll()
      }
      onVisible={() =>
        triggerImpressions('game-card-shown', {
          layout,
          'game-name': gameNameEn,
          'game-code': gameCode,
          ...additionalAttributes,
        })
      }
      reffererLayout={reffererLayout}
    >
      <Image
        src={`https://static.gamezop.com/${gameCode}/${imageSize}/square.png`}
        alt={gameName}
        fill
        sizes='(max-width: 150px) 20vw, 162px'
        className={s.card_image}
        priority
      />
    </GameLinkWithImpressionTracking>
  )
}

export default CardSquare
